import script from "./SlotsExerciseMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./SlotsExerciseMain.vue?vue&type=script&setup=true&lang=ts"

import "./SlotsExerciseMain.vue?vue&type=style&index=0&id=98f85e22&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98f85e22"]])

export default __exports__